import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import FullScreenDialog from "../../../../common/core-ui/FullScreenDialog";
import DotLoader from "../../../../common/core-ui/DotLoader";
import styles from "./UpdatingLibraryDialog.module.scss";
import { FetcherWithSubmitPromise } from "../../../../common/core-ui/usePromiseFetcher";
import { UpdateResult } from "../../actions/update-library/updateLibrary";

export default function UpdatingLibraryDialog({
  onRequestClose,
  fetcher,
}: {
  onRequestClose: () => void;
  fetcher: FetcherWithSubmitPromise<UpdateResult>;
}) {
  useEffect(() => {
    if (fetcher.state === "idle") {
      onRequestClose();
    }
  }, [onRequestClose, fetcher]);

  return (
    <FullScreenDialog
      onRequestClose={onRequestClose}
      className={styles.dialog}
      hideCloseButton
    >
      <div className={styles.content}>
        <DotLoader />
        <div className={styles.updating}>
          <FormattedMessage defaultMessage="Updating Library" />
        </div>
        <div>
          <FormattedMessage defaultMessage="This may take a few moments" />
        </div>
      </div>
    </FullScreenDialog>
  );
}
